"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHTMLButtonElement;
function isHTMLButtonElement(button) {
  return button.matches('button');
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc0hUTUxCdXR0b25FbGVtZW50IiwiYnV0dG9uIiwibWF0Y2hlcyJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL0F0dGFjaG1lbnQvVGV4dC9wcml2YXRlL2lzSFRNTEJ1dHRvbkVsZW1lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gaXNIVE1MQnV0dG9uRWxlbWVudChidXR0b246IEhUTUxFbGVtZW50KTogYnV0dG9uIGlzIEhUTUxCdXR0b25FbGVtZW50IHtcbiAgcmV0dXJuIGJ1dHRvbi5tYXRjaGVzKCdidXR0b24nKTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQWUsU0FBU0EsbUJBQW1CQSxDQUFDQyxNQUFtQixFQUErQjtFQUM1RixPQUFPQSxNQUFNLENBQUNDLE9BQU8sQ0FBQyxRQUFRLENBQUM7QUFDakMifQ==